import { c as _c } from "react/compiler-runtime";
import { useRollbar } from '@rollbar/react';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { UserInterface } from 'shared/types/user-interface';
import useSWR, { useSWRConfig } from 'swr';
import { DASHBOARD_USER_DATA_API, PUBLIC_USER_DATA_API } from '../constants/api';
import { publicRoutes } from '../constants/public-routes';
import { isAuthorized } from '../utils/is-authorized';
export const useDashboardUser = () => {
  const $ = _c(26);
  const router = useRouter();
  const rollbar = useRollbar();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get,
      stopErrorPropagation: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  const {
    cache
  } = useSWRConfig();
  let isDashboard;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[1] !== cache || $[2] !== fetcher || $[3] !== router) {
    const publicUser = cache.get(PUBLIC_USER_DATA_API)?.data;
    let t5;
    if ($[9] !== router) {
      t5 = publicRoutes.some(route => router.pathname.includes(route));
      $[9] = router;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    isDashboard = !t5;
    t2 = useSWR;
    t3 = isDashboard && DASHBOARD_USER_DATA_API;
    t4 = fetcher;
    t1 = publicUser && isAuthorized(publicUser) ? publicUser : undefined;
    $[1] = cache;
    $[2] = fetcher;
    $[3] = router;
    $[4] = isDashboard;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    isDashboard = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  let t5;
  if ($[11] !== t1) {
    t5 = {
      fallbackData: t1
    };
    $[11] = t1;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const {
    data: dashboardUser,
    mutate: dashboardMutate
  } = t2(t3, t4, t5);
  let t6;
  if ($[13] !== dashboardUser || $[14] !== isDashboard || $[15] !== rollbar) {
    t6 = () => {
      if (dashboardUser && isDashboard) {
        rollbar.configure({
          payload: {
            person: {
              id: dashboardUser.id,
              username: `${dashboardUser.firstName} ${dashboardUser.lastName}`
            }
          }
        });
      }
    };
    $[13] = dashboardUser;
    $[14] = isDashboard;
    $[15] = rollbar;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== dashboardUser || $[18] !== isDashboard || $[19] !== rollbar || $[20] !== router) {
    t7 = [dashboardUser, rollbar, router, isDashboard];
    $[17] = dashboardUser;
    $[18] = isDashboard;
    $[19] = rollbar;
    $[20] = router;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  useEffect(t6, t7);
  const isDisabled = dashboardUser ? !dashboardUser.impersonator && !dashboardUser.enabled : false;
  let t8;
  if ($[22] !== dashboardMutate || $[23] !== dashboardUser || $[24] !== isDisabled) {
    t8 = {
      dashboardUser,
      dashboardMutate,
      isDisabled
    };
    $[22] = dashboardMutate;
    $[23] = dashboardUser;
    $[24] = isDisabled;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
};